import { DEFINE_OPTION } from '../../constants';
import { rowStructure } from '../../redux/features/burst/types';
import createEmptyRow from './createEmptyRow';
import getNumberOfInactiveRows from './getNumberOfInactiveRows';

const splitInputAcrossWeeks = (
  rows: rowStructure[],
  target: DEFINE_OPTION,
  totalToSplit: number
): rowStructure[] => {
  const numberOfInactiveRows = getNumberOfInactiveRows(rows);
  const totalRowsToSplitAcross = rows.length - numberOfInactiveRows;
  const calculatedWeeklySplit = totalToSplit / totalRowsToSplitAcross;

  return rows.map((row) => {
    if (!row.active) {
      return createEmptyRow(row);
    }

    const targetValues = calculateTargetValues(
      target,
      calculatedWeeklySplit,
      row
    );

    return targetValues;
  });
};

const round = (value: number) => {
  return Math.round(value * 10) / 10;
};

const calculateTargetValues = (
  target: DEFINE_OPTION,
  calculatedWeeklySplit: number,
  row: rowStructure
): rowStructure => {
  let budget;
  let impact;
  let tarps;

  const cpt = row.cpt;
  const cpm = row.cpm;

  switch (target) {
    case DEFINE_OPTION.TARPS:
      tarps = round(calculatedWeeklySplit);
      budget = round(cpt * tarps);
      impact = isFinite(budget / cpm) ? round(budget / cpm) : 0;
      break;
    case DEFINE_OPTION.BUDGET:
      budget = round(calculatedWeeklySplit);
      tarps = isFinite(budget / cpt) ? round(budget / cpt) : 0;
      impact = isFinite(budget / cpm) ? round(budget / cpm) : 0;
      break;
    case DEFINE_OPTION.ZEROS:
      impact = round(calculatedWeeklySplit);
      budget = round(cpm * impact);
      tarps = isFinite(budget / cpt) ? round(budget / cpt) : 0;
      break;
  }

  return {
    ...row,
    budget,
    tarps,
    impact
  };
};

export default splitInputAcrossWeeks;
